import { Route, Routes } from "react-router-dom";
import Homepage from "../container/homepage";

const AllPagesRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
      </Routes>
    </>
  );
};
export default AllPagesRoutes;
